export default {
  getIncome: (state) => state.income,
  getDownPayment: (state) => state.downPayment,
  getBuyingPowerData: (state) => state.buyingPowerData,
}
